import { useQuery } from "@tanstack/react-query"
import { invitationsQuery } from "../lib/invitationsQuery"

export function useInvitationsQuery() {
  return useQuery(invitationsQuery())
}
